import React, { useEffect, useState } from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/Reducer";
import { clearApiCallMessage } from "../../redux/Action/Action";
import "./toastNotifier.scss";

const ToastNotifier: React.FC = () => {
  const dispatch = useDispatch();
  const { message, error } = useSelector(
    (state: RootState) => state.toastMessageReducer
  );
  const [show, setShow] = useState(false);

  
  useEffect(() => {
    if (message) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        dispatch(clearApiCallMessage()); // clear state after toast timeout
      }, 3000);
      return () => clearTimeout(timer);
    }
    else{
      setShow(false);
    }
  }, [message, dispatch]);

  return (
    <div className={`position-fixed top-0 end-0 p-3`} style={{ zIndex: 9999 }}>
      <Toast isOpen={show}>
        <ToastHeader
          icon={false}
          className={error ? "toast-header-error" : "toast-header-success"}
        >
          {error ? "Failure" : "Success"}
        </ToastHeader>
        <ToastBody className={error ? "toast-failure" : "toast-success"}>
          {message}
        </ToastBody>
      </Toast>
    </div>
  );
};

export default ToastNotifier;
